<template>
  <landing>
    <b-spinner></b-spinner>
  </landing>
</template>

<script>
import Landing from '@/components/Landing.vue';

export default {
  name: 'GettingReady',
  components: {
    Landing
  }
};
</script>
